import ReportsModule from "../../modules/reports";
import { FadeInt2Div } from "../../styledComponents/animation";

const Reports = () => {
	return (
		<>
			<FadeInt2Div>
				<ReportsModule />
			</FadeInt2Div>
		</>
	);
};

export default Reports;
